import { env } from '@/lib/env'
import { appendAuthToken } from '@/lib/url/appendAuthToken'

/**
 * Resolve place image URLs — converts proxy-relative paths and legacy
 * direct Google URLs into working proxy URLs through our API server.
 */
export function resolveImageUrl(url: string | undefined): string | undefined {
  if (!url) return undefined

  // New proxy-relative URLs: prepend API base
  if (url.startsWith('/places/photo')) {
    return appendAuthToken(`${env.apiBaseUrl}${url}`)
  }

  // Legacy: direct Google Places photo URL with embedded key
  const photoMatch = url.match(
    /places\.googleapis\.com\/v1\/(places\/[^/]+\/photos\/[^/]+)\/media/
  )
  if (photoMatch) {
    return appendAuthToken(`${env.apiBaseUrl}/places/photo?name=${encodeURIComponent(photoMatch[1])}&maxWidth=900`)
  }

  // Legacy: Google Static Maps URL with embedded key
  if (url.includes('maps.googleapis.com/maps/api/staticmap')) {
    try {
      const center = new URL(url).searchParams.get('center')
      if (center) {
        return appendAuthToken(`${env.apiBaseUrl}/places/photo?name=${encodeURIComponent(center)}&type=staticmap`)
      }
    } catch { /* malformed URL, pass through */ }
  }

  // Legacy: Google Street View URL with embedded key
  if (url.includes('maps.googleapis.com/maps/api/streetview')) {
    try {
      const location = new URL(url).searchParams.get('location')
      if (location) {
        return appendAuthToken(`${env.apiBaseUrl}/places/photo?name=${encodeURIComponent(location)}&type=streetview`)
      }
    } catch { /* malformed URL, pass through */ }
  }

  // Non-Google URLs (user-uploaded, etc.) pass through unchanged
  return url
}
